import { render, staticRenderFns } from "./DocumentTabs.vue?vue&type=template&id=3f402455&"
import script from "./DocumentTabs.vue?vue&type=script&lang=ts&"
export * from "./DocumentTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports